

































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import { UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import { getCountryName, getStateName } from "@/lib/i18nHelpers";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";

export default defineComponent({
  name: "FilterLocation",
  components: { BaseButton, BaseIcon, CustomScroll, BaseInput },
  props: {
    value: { type: Array as PropType<UserLocation[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const location = ref("");
    const showOptions = ref(false);
    const options = ref<(BlockedLocationAutocomplete & { text: string })[]>([]);
    const selectedLocations = ref<(UserLocation & { text: string })[]>([]);
    const isSelectedFilters = computed(() => !!props.value.length);

    const optionsToView = computed(() =>
      options.value.filter(i => !selectedLocations.value.some(y => y.text === i.text))
    );

    const mappedLocations = (locations: BlockedLocationAutocomplete[]) => {
      return locations.map(item => {
        let result = "";
        if (item.countryCode) {
          result += getCountryName(item.countryCode);
        }

        if (item.stateCode && item.countryCode) {
          result += `, ${getStateName(item.stateCode, item.countryCode)}`;
        }

        if (item.city) {
          result += `, ${item.city}`;
        }

        return {
          text: result,
          ...item,
        };
      });
    };

    const getLocations = debounce(async (text?: string) => {
      if (!text) {
        showOptions.value = false;
        return;
      }
      const response = await providers.BlockedLocationsProvider.searchAutocomplete({ text });
      options.value = mappedLocations(response);
      showOptions.value = !!optionsToView.value.length;
    }, 500);

    const setLocation = (value: BlockedLocationAutocomplete & { text: string }) => {
      showOptions.value = false;
      location.value = "";
      selectedLocations.value.push(value);
      emit(
        "input",
        selectedLocations.value.map(({ city, stateCode, countryCode }) => ({ city, countryCode, stateCode }))
      );
    };

    const excludeLocation = (index: number) => {
      selectedLocations.value = selectedLocations.value.filter((_, i) => i !== index);
      emit(
        "input",
        selectedLocations.value.map(({ city, stateCode, countryCode }) => ({ city, countryCode, stateCode }))
      );
    };

    const clear = () => {
      selectedLocations.value = [];
      emit("input", []);
    };

    const created = () => {
      if (!props.value.length) return;
      selectedLocations.value = mappedLocations(props.value);
    };

    created();

    return {
      location,
      showOptions,
      optionsToView,
      selectedLocations,
      isSelectedFilters,
      getLocations,
      setLocation,
      excludeLocation,
      clear,
    };
  },
});
